import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';

export default class KpiApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('kpi'), options);
  }

  // =============================================================================
  //                            Kind APIS
  // =============================================================================

  public GetManufacturerReporting() {
    const query = '/kpi/v1/reporting/manufacturer';
    return this.get(query);
  }

  public GetDashboardList() {
    const query = '/kpi/v1/reporting/dashboard/list/admin';
    return this.get(query);
  }

  public GetAggregationList() {
    const query = '/kpi/v1/reporting/aggregation/list/admin';
    return this.get(query);
  }

  public GetDashboard(entityCode: string | number) {
    const query = `/kpi/v1/reporting/dashboard/admin/${entityCode}`;
    return this.get(query);
  }

  public GetAggregation(entityCode: string | number) {
    const query = `/kpi/v1/reporting/aggregation/admin/${entityCode}`;
    return this.get(query);
  }

  public GetAdminReportingTableAs(
    orgaId: number,
    dashboardId: string | number,
    esExtraParams?: any,
    isXls: boolean = false,
  ) {
    const query = `/kpi/v2/reporting/${dashboardId}/as/${orgaId}`;
    const param: any = { es_extra_params: esExtraParams };
    if (isXls) {
      param.xls = true;
      return this.getBlob(query, '', param, true);
    }
    return this.post(query, param);
  }

  public GetAdminReportingTable(
    dashboardId: string | number,
    esExtraParams?: any,
    isXls: boolean = false,
  ) {
    const query = `/kpi/v2/reporting/${dashboardId}`;
    const param: any = { es_extra_params: esExtraParams };
    if (isXls) {
      param.xls = true;
      return this.getBlob(query, '', param, true);
    }
    return this.post(query, param);
  }

  public PushTranslationKeysAdminReportingTable(
    dashboardId: string | number,
    esExtraParams?: any,
    dryRun?: boolean,
  ) {
    const query = `/kpi/v2/reporting/${dashboardId}/push_translation`;
    const param = { es_extra_params: esExtraParams, dry_run: dryRun };
    return this.post(query, param);
  }

  public PushTranslationKeysAdminReportingTableAs(
    orgaId: number,
    dashboardId: number | string,
    esExtraParams?: any,
    dryRun?: boolean,
  ) {
    const query = `/kpi/v2/reporting/${dashboardId}/as/${orgaId}/push_translation`;
    const param = { es_extra_params: esExtraParams, dry_run: dryRun };
    return this.post(query, param);
  }
}
